import $ from 'jquery';

$(function () {
	// Always load images on watchlist because of print layout
	$('.watchlist img.lazyload').addClass('lazypreload');
});
